"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProductCourseCollection = void 0;
var react_1 = __importDefault(require("react"));
var CourseChip_1 = __importDefault(require("../CourseChip"));
var Button_1 = __importDefault(require("../../basics/Button"));
var Lockup_1 = __importDefault(require("../../basics/Lockup"));
var PriceTag_1 = __importDefault(require("../PriceTag"));
var Card_1 = __importDefault(require("../../basics/Card"));
var styles_1 = require("./styles");
var CONTENT_AMOUNT = { small: 16, medium: 20, large: 24 };
var ProductCourseCollection = function (_a) {
    var title = _a.title, image = _a.image, description = _a.description, price = _a.price, fullPrice = _a.fullPrice, _b = _a.courses, courses = _b === void 0 ? [] : _b, buttonOnClick = _a.buttonOnClick, _c = _a.buttonText, buttonText = _c === void 0 ? 'Add to Cart' : _c, _d = _a.buttonIsDisabled, buttonIsDisabled = _d === void 0 ? false : _d, commonProps = __rest(_a, ["title", "image", "description", "price", "fullPrice", "courses", "buttonOnClick", "buttonText", "buttonIsDisabled"]);
    return (react_1.default.createElement(Card_1.default, __assign({ "data-component-name": "ProductCourseCollection" }, commonProps, { header: react_1.default.createElement(styles_1.ImageWrapper, null,
            react_1.default.createElement(styles_1.Image, __assign({}, image, { alt: "".concat(title, " artwork"), fit: "cover" })),
            react_1.default.createElement(styles_1.HeaderInfo, null,
                react_1.default.createElement(PriceTag_1.default, { level: "2", fullPrice: fullPrice, floating: true }, price))) }),
        react_1.default.createElement(styles_1.Content, { amount: CONTENT_AMOUNT },
            react_1.default.createElement(Lockup_1.default, { title: title, subtitle: description, level: "4", align: "left", titleColor: "GREY_90" }),
            react_1.default.createElement(styles_1.Courses, null,
                react_1.default.createElement(styles_1.IncludedLabel, { level: "1", color: "GREY_70" }, "Included in this collection"),
                courses.map(function (course, i) { return (react_1.default.createElement(CourseChip_1.default, __assign({ key: i }, course))); })),
            react_1.default.createElement(Button_1.default, { version: "outline", onClick: buttonOnClick, disabled: buttonIsDisabled, fullWidth: true }, buttonText))));
};
exports.ProductCourseCollection = ProductCourseCollection;
exports.default = exports.ProductCourseCollection;
